export class EnvConfigStart {
  private configUrl = 'assets/config/configuracoes.json';

  getConfig() {
    return fetch(this.configUrl)
      .then(res => res.json())
      .then(data => data)
      .catch(err => window.alert('Houve um erro ao inicializar as variáveis da aplicação: ' + err));
  }
}